import { ANIMATION_DURATION } from "components/Message/configs";
import styled from "styled-components";
import { fadeIn } from "theme/animations";
import { InnerContainer } from "../styles";

interface StyledInnerContainerProps {
  isVisible: boolean;
}

export const StyledInnerContainer = styled(
  InnerContainer
)<StyledInnerContainerProps>`
  transform: translateX(-100%);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${ANIMATION_DURATION};
  animation: ${fadeIn} ${ANIMATION_DURATION};
  padding: 48px 32px;
`;
